import { render } from "./Paginator.vue?vue&type=template&id=4d1aa5a1&scoped=true"
import script from "./Paginator.vue?vue&type=script&lang=ts"
export * from "./Paginator.vue?vue&type=script&lang=ts"

import "./Paginator.vue?vue&type=style&index=0&id=4d1aa5a1&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4d1aa5a1"

export default script